import React from 'react';
import PhotoCapture from './PhotoCapture';

export default function Question({ question, value, onChange, tokenData }) {
  const { question_code, question_text, question_type, category, requires_photo, help_text } = question;
  const isPhoto = requires_photo || question_type === 'photo';

  return (
    <div style={{ width:'100%', boxSizing:'border-box' }}>
      <div style={{ fontSize:11, color:'#4ade80', letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:12 }}>
        {category?.replace(/_/g, ' ')}
      </div>
      <div style={{ fontSize:20, fontWeight:600, color:'#fff', lineHeight:1.4, marginBottom:8, wordBreak:'break-word' }}>
        {question_text}
      </div>
      {help_text && (
        <div style={{ fontSize:13, color:'#555', marginBottom:24, lineHeight:1.5 }}>
          {help_text}
        </div>
      )}
      {!help_text && <div style={{ marginBottom:24 }}/>}

      {isPhoto ? (
        <PhotoCapture
          questionCode={question_code}
          submissionId={tokenData.submission_id}
          tenantId={tokenData.tenant_id}
          value={value}
          onChange={onChange}
        />
      ) : question_type === 'yes_no' ? (
        <div style={{ display:'flex', gap:12, width:'100%', boxSizing:'border-box' }}>
          {['Yes', 'No'].map(opt => (
            <button
              key={opt}
              onClick={() => onChange(opt)}
              style={{
                flex:1, height:52, borderRadius:8, fontSize:15, fontWeight:500,
                cursor:'pointer', transition:'all 0.15s',
                background: value === opt ? '#4ade80' : '#141414',
                border: value === opt ? '2px solid #4ade80' : '2px solid #222',
                color: value === opt ? '#000' : '#666',
                minWidth:0,
              }}
            >
              {opt}
            </button>
          ))}
        </div>
      ) : question_type === 'select' ? (
        <select
          value={value}
          onChange={e => onChange(e.target.value)}
          style={{
            width:'100%', height:52, padding:'0 16px',
            background:'#141414', border:'2px solid #222',
            borderRadius:8, color: value ? '#fff' : '#444',
            fontSize:15, boxSizing:'border-box',
          }}
        >
          <option value="">Select an option...</option>
          {(question.options || []).map(opt => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      ) : question_type === 'numeric' ? (
        <input
          type="number"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Enter a number..."
          style={{
            width:'100%', height:52, padding:'0 16px',
            background:'#141414', border:'2px solid #222',
            borderRadius:8, color:'#fff', fontSize:18,
            fontWeight:500, boxSizing:'border-box', outline:'none',
          }}
        />
      ) : (
        <textarea
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Type your answer here..."
          rows={4}
          style={{
            width:'100%', padding:'14px 16px',
            background:'#141414', border:'2px solid #222',
            borderRadius:8, color:'#fff', fontSize:15,
            lineHeight:1.5, resize:'vertical',
            boxSizing:'border-box', outline:'none',
          }}
        />
      )}
    </div>
  );
}
